import { WIDTH_SIDEBAR_COLLAPSE } from 'constant';
import useWindowSize from 'hooks/useWindowSize';
import React, { useContext, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { getIsLoggedIn } from 'store/atom-state/authen-atom';
import Navigation from 'app/components/Navigation';

/**
 * create context
 */

export const LayoutContext = React.createContext({
  collapse: false,
});
LayoutContext.displayName = 'LayoutContext';

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) return;
  return context;
};

const Layout = props => {
  const { children } = props;
  const windowSize: any = useWindowSize();
  const isLoggedIn = useRecoilValue(getIsLoggedIn);
  const [collapse, setCollapse] = useState(false);

  /**
   * on toggle
   *
   */
  const toggleSidebar = () => {
    setCollapse(!collapse);
  };

  const value: any = {
    isLoggedIn,
    collapse,
    toggleSidebar,
  };

  const smallSize = windowSize?.width < 768;
  return (
    <LayoutContext.Provider value={value}>
      <div className="admin">
        {isLoggedIn && <Navigation />}
        <div
          className="program-main"
          style={
            !isLoggedIn
              ? {}
              : collapse
              ? {
                  width: smallSize
                    ? '100%'
                    : `calc(100% - ${WIDTH_SIDEBAR_COLLAPSE})`,
                  left: smallSize ? 0 : WIDTH_SIDEBAR_COLLAPSE,
                  margin: 0,
                }
              : {
                  width: `calc(100% - 256px)`,
                  left: '256px',
                  margin: 0,
                }
          }
        >
          {children}
        </div>
      </div>
    </LayoutContext.Provider>
  );
};

export default Layout;
